import {
    Validators,
    AbstractControl,
    ValidatorFn,
    ValidationErrors,
  } from '@angular/forms';
  
  import { isPresent } from '../utils/is-present';
  
  export const postCode: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    if (isPresent(Validators.required(control))) {
      return null;
    }
  
    const v: string = control.value;
    return /^(([A-Z][0-9]{1,2})|(([A-Z][A-HJ-Y][0-9]{1,2})|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9]?[A-Z])))) [0-9][A-Z]{2}$/g.test(v)
      ? null
      : { postCode: true };
  };
  